<template>
  <div class="app-container">
    <div class="outer">
      <div class="page-header" v-if="isSwitchCategory">
        <h2>切换商品类目</h2>
        <p class="page-desc">请选择新的商品类目，切换后品牌、属性、规格将丢失</p>
      </div>
      
      <Steps :active-steps="activeSteps" />
      <div class="back-btn-parent">
        <el-button
          v-if="activeSteps === 1"
          class="back-btn"
          type="primary"
          size="small"
          @click="toBack()"
        >
          上一步
        </el-button>
      </div>

      <div v-if="activeSteps === 0">
        <SelectCat
          class="margin_right_10"
          :show-only-agricultural="isSwitchCategory || isRecommendGoods"
          @change="selectCat(arguments)"
        />
        <el-button
          class="margin_top_10"
          type="primary"
          size="mini"
          @click="toNext()"
        >
          下一步
        </el-button>
      </div>
      <div v-if="activeSteps === 1">
        <GoodsBase />
      </div>
    </div>
  </div>
</template>

<script>
import './style.scss';
import Steps from './components/steps';
import SelectCat from './components/selectCat';
import GoodsBase from './components/goodsBase/index.vue';

export default {
  components: {
    Steps,
    SelectCat,
    GoodsBase,
  },
  data() {
    return {
      query: {},
      activeSteps: 0,
      goodsType: '',
      backendCategoryId: '',
      catId: [],
      isSwitchCategory: false, // 是否是切换类目模式
      isRecommendGoods: false, // 是否是推荐商品
    };
  },
  mounted() {
    this.query = this.$route.query;
    this.isSwitchCategory = this.query.from === 'switchCategory';
    
    // 判断是否是推荐商品
    // 通过from参数判断来源：'recommend'表示来自推荐商品页面，'index'表示来自店铺商品页面
    // 如果没有from参数，则通过goodsBuyType判断（向后兼容）
    this.isRecommendGoods = this.query.isRecommendGoods;
    
    console.log('add.vue mounted:', {
      query: this.query,
      isSwitchCategory: this.isSwitchCategory,
      isRecommendGoods: this.isRecommendGoods,
      goodsBuyType: this.query.goodsBuyType
    });
    
    if (this.isSwitchCategory) {
      // 切换类目模式，直接进入类目选择步骤
      this.activeSteps = 0;
      this.goodsType = this.query.goodsType ? Number(this.query.goodsType) : 1;
    } else {
      // 新增商品模式
      this.activeSteps = this.query.activeSteps
        ? Number(this.query.activeSteps)
        : 0;
      this.goodsType = Number(this.query.goodsType);
    }
  },
  methods: {
    // 检查推荐商品是否可以切换类目
    async checkSwitchCategory() {
      if (!this.query.goodsId || this.query.goodsBuyType !== '1') {
        return true; // 不是推荐商品，直接返回true
      }
      
      try {
        const resp = await this.$axios.get(
          this.$api.goodsmanage.trade_goods_switch_category_check,
          { params: { goodsId: this.query.goodsId } }
        );
        if (resp.code === 0 && ((resp.data && resp.data == 0) || !resp.data)) {
          return true;
        } else {
          // this.$message.error('该商品当前状态不允许切换类目');
          return false;
        }
      } catch (err) {
        this.$message.error(err.message);
        return false;
      }
    },
    selectCat(e) {
      console.log(e);
      this.catId = e[0];
      this.goodsType = e[1];
    },
    toNext() {
      if (this.catId.length > 0) {
        this.activeSteps = 1;
        this.backendCategoryId = this.catId[this.catId.length - 1];
        
        if (this.isSwitchCategory) {
          // 切换类目模式，先进行校验
          this.checkSwitchCategory().then(async (canSwitch) => {
            if (!canSwitch) {
              // 校验失败，重置步骤
              this.activeSteps = 0;
              return;
            }
            
            // 校验通过，跳转到商品编辑页面
            // 兼容处理：如果storeId为空或为字符串"0"，从userInfo中获取
            let storeId = this.query.storeId;
            if (!storeId || storeId === '0') {
              const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
              if (userInfo.storeList && userInfo.storeList.length > 0) {
                storeId = userInfo.storeList[0].storeId;
              }
            }
            
            this.$router.push({
              path: '/nb/goods/detail',
              query: {
                type: 'edit',
                goodsId: this.query.goodsId,
                storeId: storeId,
                suppliersId: this.query.suppliersId,
                goodsBuyType: this.query.goodsBuyType,
                backendCategoryId: this.backendCategoryId,
                from: 'switchCategory', // 保持推荐商品身份
                goodsType: this.query.goodsType,
                isRecommendGoods: this.isRecommendGoods, // 保持推荐商品标识
              },
            });
          });
        } else {
          // 新增商品模式
          if (this.isRecommendGoods) {
            // 若是新增推荐商品，跳转新增推荐商品页
            this.$router.replace({
              query: {
                ...this.query,
                activeSteps: 1,
                goodsType: this.goodsType,
                backendCategoryId: this.backendCategoryId,
                type: 'add',
              },
            });
          } else {
            // 若是新增店铺商品，跳转原新增商品页
            this.$router.replace({
              query: {
                ...this.query,
                activeSteps: 1,
                goodsType: this.goodsType,
                backendCategoryId: this.backendCategoryId,
                type: 'add',
              },
            });
          }
        }
      } else {
        this.$message({
          message: '请选择类目',
          type: 'warning',
        });
      }
    },
    toBack() {
      if (this.isSwitchCategory) {
        // 切换类目模式，直接返回上一页
        this.$router.go(-1);
        return;
      }
      
      this.$confirm('确定返回上一步吗？返回后商品信息将不会保存', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.activeSteps = 0;
          this.goodsType = null;
          this.backendCategoryId = '';
          this.catId = [];
          
          // 兼容处理：如果storeId为空或为字符串"0"，从userInfo中获取
          let storeId = this.$route.query.storeId;
          if (!storeId || storeId === '0') {
            const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
            if (userInfo.storeList && userInfo.storeList.length > 0) {
              storeId = userInfo.storeList[0].storeId;
            }
          }
          
          this.$router.replace({
            path: '/nb/goods/add',
            query: {
              storeId: storeId,
            },
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="scss">
.page-header {
  margin-bottom: 30px;
  text-align: center;

  h2 {
    font-size: 24px;
    color: #303133;
    margin: 0 0 10px 0;
  }

  .page-desc {
    color: #909399;
    margin: 0;
    font-size: 14px;
  }
}


</style>
